import { Button, Modal, Space, Typography } from "antd";

const { Text } = Typography;

export const ModalControleEstacao = ({
  visible,
  onCancel,
  onSelect,
  loading,
  title,
  description,
  primaryAction,
  secondaryAction,
}) => {
  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Text style={{ fontSize: 16, fontWeight: 500 }}>{description}</Text>

        <Space
          style={{
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <Button
            type={primaryAction.type}
            danger={primaryAction.danger}
            loading={loading}
            onClick={() => onSelect(primaryAction.value)}
            style={primaryAction.style}
          >
            {primaryAction.label}
          </Button>

          <Button
            type={secondaryAction.type}
            danger={secondaryAction.danger}
            loading={loading}
            onClick={() => onSelect(secondaryAction.value)}
            style={secondaryAction.style}
          >
            {secondaryAction.label}
          </Button>

          <Button disabled={loading} onClick={onCancel}>
            Cancelar
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};
